/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_CsInputs */

const en_contact_cs = /** @type {(inputs: Contact_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Support`)
};

const ar_contact_cs = /** @type {(inputs: Contact_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اتصل بالدعم`)
};

const de_contact_cs = /** @type {(inputs: Contact_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support kontaktieren`)
};

const es_contact_cs = /** @type {(inputs: Contact_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contactar con el servicio de asistencia`)
};

const fr_contact_cs = /** @type {(inputs: Contact_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacter l'assistance`)
};

const it_contact_cs = /** @type {(inputs: Contact_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatta il Supporto`)
};

const ja_contact_cs = /** @type {(inputs: Contact_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サポートに問い合わせる`)
};

const ko_contact_cs = /** @type {(inputs: Contact_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지원 문의하기`)
};

const pt_br_contact_cs = /** @type {(inputs: Contact_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contate o suporte`)
};

const ru_contact_cs = /** @type {(inputs: Contact_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Служба поддержки здесь`)
};

const th_contact_cs = /** @type {(inputs: Contact_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ติดต่อฝ่ายสนับสนุน`)
};

const tr_contact_cs = /** @type {(inputs: Contact_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Destek ekibiyle iletişime geç`)
};

const zh_cn_contact_cs = /** @type {(inputs: Contact_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系客服`)
};

const zh_tw_contact_cs = /** @type {(inputs: Contact_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`聯絡客服`)
};

/**
* | output |
* | --- |
* | "Contact Support" |
*
* @param {Contact_CsInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const contact_cs = /** @type {((inputs?: Contact_CsInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_CsInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_cs(inputs)
	if (locale === "ar") return ar_contact_cs(inputs)
	if (locale === "de") return de_contact_cs(inputs)
	if (locale === "es") return es_contact_cs(inputs)
	if (locale === "fr") return fr_contact_cs(inputs)
	if (locale === "it") return it_contact_cs(inputs)
	if (locale === "ja") return ja_contact_cs(inputs)
	if (locale === "ko") return ko_contact_cs(inputs)
	if (locale === "pt_br") return pt_br_contact_cs(inputs)
	if (locale === "ru") return ru_contact_cs(inputs)
	if (locale === "th") return th_contact_cs(inputs)
	if (locale === "tr") return tr_contact_cs(inputs)
	if (locale === "zh_cn") return zh_cn_contact_cs(inputs)
	return zh_tw_contact_cs(inputs)
});